import { Component, Input, OnInit } from '@angular/core';
import { clone } from 'lodash';
import { ProductConfigOpsType, ProductConfigStep, V6ProductType } from '../../../../../../core/enums';
import { NotifyType } from '../../../../../../core/enums/NotifyType';
import { CartItem, ICartItemResponse } from '../../../../../../core/models';
import { AppNotifyService } from '../../../../../../core/services/app-notify.service';
import { CartService } from '../../../../../../core/services/cart.service';
import { CommonService } from '../../../../../../core/services/common.service';
import { QuoteService } from '../../../../../../core/services/quote.service';
import { UserService } from '../../../../../../core/services/user.service';
import { V6macroService } from '../../../../../../core/services/v6macro.service';
import { V6productService } from '../../../../../../core/services/v6product.service';
import { V6translationService } from '../../../../../../core/services/v6translation.service';
import { Router } from '@angular/router';
import pdfMake from "pdfmake/build/pdfmake.js";
import pdfFonts from "pdfmake/build/vfs_fonts.js";
import * as fs from 'file-saver';
import { formatDate } from '@angular/common';
//import { debug } from 'util';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-bp3',
  templateUrl: './bp3.component.html',
  styleUrls: ['./bp3.component.scss']
})
export class Bp3Component implements OnInit {
  @Input() quoteItemId!: string;
  addToQuoteVisible: boolean = true;
  addToCartVisible: boolean = true;

  constructor(private v6productService: V6productService,
    private v6translationService: V6translationService,
    private cartService: CartService,
    private userService: UserService,
    private appNotify: AppNotifyService,
    private quoteService: QuoteService,
    private commonService: CommonService,
    private v6MacroService: V6macroService,
    private router: Router) { }

  get productModel() {
    return this.v6productService.bp3PreviewModel;
  }
  set productModel(pm) {
    this.v6productService.bp3PreviewModel = pm;
  }


  ngOnInit() {
    console.log('bp3');
    this.productModel.resourceFrame.attributeFiltersForUI = this.v6productService.organizeControlsInTabluarForm(this.productModel.resourceFrame.attributeFilters, true);
    this.productModel.nestedFrames.forEach((el, index) => {
      el.attributeFiltersForUI = this.v6productService.organizeControlsBySectionOnBP3(el.attributeFilters);
    })
    console.log(this.productModel);
    this.actionButtonVisibilityCheck();
  }

  ppfinRelatedModOnSummaryScreen() {
    const ppFin = this.productModel.productAttributes.find(x => x.v6ReferenceCode === 'PushPull Finish');
    if (ppFin) {
      this.productModel.nestedFrames.forEach((el, index) => {
        const p = el.attributeFilters.find(x => x.v6ReferenceCode === 'PushPull Finish');
        if (p) {
          ppFin.show = true;
          ppFin.isReported = true;
          ppFin.code = p.code;
          ppFin.value = p.value;
          p.show = false;
        }
      });
    }
  }
  goBack() {
    this.v6productService.currentProductConfigStep = ProductConfigStep.CONFIG_DETAILS;
  }
  cartItem: any;
  addItemInProgress: boolean;
  addConfiguredItemToCart() {
    this.addItemInProgress = true;
    this.cartItem = clone(this.productModel);
    //cartItem.userId = this.userService.readUserObject.userId;
    this.cartItem.customerNumber = this.userService.readUserObject.customerNumber;
    this.cartItem.itemDescription = this.productModel.computedName;
    this.cartItem.cartItemCommonId = this.productModel.quoteItemCommonId;
    this.cartItem.itemNumber = this.productModel.reference;
    this.cartItem.quantity = this.productModel.quantity;
    this.cartItem.cartItemIdToRemove = this.quoteItemId;
    //cartItem.extendedPrice = +this.productModel.unitNetSellPrice;
    this.cartItem.unitPrice = +this.productModel.unitNetSellPrice;
    this.cartItem.listPrice = +this.productModel.unitGrossSellPrice;
    //cartItem.extendedPrice = +this.productModel.unitGrossSellPrice;
    if (this.productModel.type === V6ProductType.KWIK_KEY_DOOR ||
      this.productModel.type === V6ProductType.KWIK_KEY_FRAME) {
      this.cartItem.productCode = this.productModel.productCode;
    }
    else {
      this.cartItem.productId = this.productModel.productId;
    }
    //cartItem.pushPullFinish = "Test";
    let extFin = this.productModel.productAttributes.find(x => x.v6ReferenceCode == 'Job/Exterior Finish');//validate this
    this.cartItem.v6SatelliteQuoteCommonId = this.productModel.quoteCommonId;
    this.cartItem.freightFamily = this.productModel.freightFamily;//'Testv6ProductCode';
    this.cartItem.configItemExtFinishCode = extFin ? extFin.value : 'Testv6ExtFinishCode';

    let ppFin = this.productModel.productAttributes.find(x => x.v6ReferenceCode == 'PushPull Finish');

    this.cartItem.pushPullFinish = ppFin ? ppFin.value : '';

    if (this.v6productService.currentConfigOPsType === ProductConfigOpsType.EDIT) {
      //update cart
    }
    this.cartItem.OrderSource=1;
    this.cartService.addConfiguredItemToCart(this.cartItem).subscribe((r: ICartItemResponse) => {
      this.addItemInProgress = false;
      this.appNotify.notify(
        NotifyType.SUCCESS,
        'Item has been added to the Cart! Navigating you to cart'
      );
      this.cartService.totalCartItem.next(r.cartItemCount);
      const routepath = `/cart`;
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([routepath]); // navigate to same route
      });
    },
      (error) => {
        this.appNotify.notify(NotifyType.ERROR, "An Error Occured!");
      });

  }
  rowItemQuote: any;
  addConfiguredItemToQuote() {
    this.addItemInProgress = true;
    this.rowItemQuote = clone(this.productModel);
    // this.rowItemQuote.isOpened = true;
    //this.rowItemQuote.userId = this.userService.readUserObject.userId;
    this.rowItemQuote.customerNumber = this.userService.readUserObject.customerNumber;
    this.rowItemQuote.itemDescription = this.productModel.productName;
    this.rowItemQuote.quoteItemCommonId = this.productModel.quoteItemCommonId;
    this.rowItemQuote.itemNumber = this.productModel.reference;//this.productModel.productCode;
    this.rowItemQuote.quantity = this.productModel.quantity;
    this.rowItemQuote.unitPrice = +this.productModel.unitNetSellPrice;
    //this.rowItemQuote.extendedPrice = +this.productModel.unitNetSellPrice;
    this.rowItemQuote.listPrice = +this.productModel.unitGrossSellPrice;
    this.rowItemQuote.itemType = 2;
    this.rowItemQuote.mode = "item-to-quote";
    //this.rowItemQuote.productCode = this.productModel.productCode;
    //this.rowItemQuote.productId = this.productModel.productName;
    if (this.productModel.type === V6ProductType.KWIK_KEY_DOOR ||
      this.productModel.type === V6ProductType.KWIK_KEY_FRAME) {
      this.rowItemQuote.productCode = this.productModel.productCode;
    }
    else {
      this.rowItemQuote.productId = this.productModel.productId;
      if (this.v6productService.currentConfigOPsType === ProductConfigOpsType.EDIT) {
        //update cart
      }
    }

    console.log("Product added");
    console.log(this.productModel.productAttributes);
    let extFin = this.productModel.productAttributes.find(x => x.v6ReferenceCode == 'Job/Exterior Finish');//validate this
    this.rowItemQuote.v6SatelliteQuoteCommonId = this.productModel.quoteCommonId;
    this.rowItemQuote.freightFamily = this.productModel.freightFamily;//'Testv6ProductCode';    
    this.rowItemQuote.configItemExtFinishCode = extFin ? extFin.value : 'Testv6ExtFinishCode';

    let ppFin = this.productModel.productAttributes.find(x => x.v6ReferenceCode == 'PushPull Finish');

    this.rowItemQuote.pushPullFinish = ppFin ? ppFin.value : '';
    if (!this.addToCartVisible) {
      this.rowItemQuote.isOpened = false;
      this.rowItemQuote.quoteCommonId = this.quoteService.selectedQuoteHeader.quoteCommonId;
      this.rowItemQuote.quoteItemCommonIdToDelete = this.quoteItemId;
      console.log(this.rowItemQuote);
      this.quoteService.addConfiguredItemToQuote(this.rowItemQuote).subscribe((response: any) => {
        this.addItemInProgress = false;
        if (response) {
          this.goToQuoteDetail();
        }
      }, error => {

      });
    }
    else {
      this.rowItemQuote.quoteCommonId = null;
      this.rowItemQuote.isOpened = true;
      if (this.productModel.type === V6ProductType.KWIK_KEY_DOOR ||
        this.productModel.type === V6ProductType.KWIK_KEY_FRAME) {
        if (this.quoteService.selectedQuoteHeader && this.quoteService.selectedQuoteHeader.quoteCommonId)
          this.rowItemQuote.quoteCommonId = this.quoteService.selectedQuoteHeader.quoteCommonId;
      }
    }
  }
  goToQuoteDetail(): void {
    console.log(this.quoteService.selectedQuoteHeader);
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/manage-quote/kawneerdirect-quotes/quote-detail']); // navigate to same route
    });
  }
  receiveData($event) {
    this.rowItemQuote = $event;
  }
  
  actionButtonVisibilityCheck() {
    console.log(this.router.url);
    var url = this.router.url;
    if (url.includes('quotes/editConfiguredProduct')) {
      this.addToCartVisible = false;
    }
    if (url.includes('cart/editConfiguredProduct')) {
      this.addToQuoteVisible = false;
    }
  }

  buildTableBody() {
    var body = [];
    if (this.productModel.resourceFrame.frameName.length > 0) {
      var row2 = new Array();
      row2.push({
        text: this.productModel.resourceFrame.frameName,
        style: "tableHeader"
      });
      body.push(row2);
    }
    if (this.productModel.resourceFrame.attributeFiltersForUI.length > 0) {
      this.productModel.resourceFrame.attributeFiltersForUI.forEach(subAttributesForUI => {
        
        if (subAttributesForUI.length > 0) {
          subAttributesForUI.forEach(cols => {
            var row = new Array();
            if (cols.type == 'sectionText') {
              row.push({
                text: cols.publishedName,
                style: "subheader"
              });
            }
            if (cols.type == 'list' && cols.show) {
              cols.options.forEach(opt => {
                if (opt.value == cols.value) {
                  var af = cols.publishedName + " \n " + opt.description + " \n ";
                  row.push([af]);
                }
              })
            }
            if (cols.type === 'text' && cols.show) {
              var af = cols.publishedName + " \n " + cols.value + " \n ";
              row.push([af]); 
            }
            if (cols.type === 'number' && cols.show) {
              var af = cols.publishedName + " \n " + cols.value + " \n ";
              row.push([af]);
            }
            if (cols.type === 'switch' && cols.show) {
              var af = cols.publishedName + " \n " + cols.value + " \n ";
              row.push([af]);
            }
            if (row.length>0) {
              body.push(row);
            }
            
          })
          
        }
      });
    }
    return body;
  }
  nestedTable = [];
  buildNestedTableBody() {

    if (this.productModel.nestedFrames.length > 0) {
      this.productModel.nestedFrames.forEach(subNestedFrames => {
        var body = [];
        var row2 = [];
        row2.push({
          text: subNestedFrames.frameName,
          style: "tableHeader"
        });
        body.push(row2);

        if (subNestedFrames.attributeFiltersForUI.length > 0) {
          subNestedFrames.attributeFiltersForUI.forEach(subAttributesForUI => {
            if (subAttributesForUI.length > 0) {
              subAttributesForUI.forEach(cols => {
                var row = new Array();
                if (cols.type == 'sectionText') {
                  row.push({
                    text: cols.publishedName,
                    style: "subheader"
                  });
                }
                if (cols.type == 'list' && cols.show) {
                  cols.options.forEach(opt => {
                    if (opt.value == cols.value) {
                      var af = cols.publishedName + " \n " + opt.description + " \n ";
                      row.push([af]);
                    }
                  })
                }
                if (cols.type === 'text' && cols.show) {
                  var af = cols.publishedName + " \n " + cols.value + " \n ";
                  row.push([af]);
                }
                if (cols.type === 'number' && cols.show) {
                  var af = cols.publishedName + " \n " + cols.value + " \n ";
                  row.push([af]);
                }
                if (cols.type === 'switch' && cols.show) {
                  var af = cols.publishedName + " \n " + cols.value + " \n ";
                  row.push([af]);
                }
                if (row.length > 0) {
                  body.push(row);
                }
              })

            }
          });
        }
        this.nestedTable.push(body);
      })
      
    }
  }
  async generatePDF() {
    var todaysDate = formatDate(new Date(), 'yyyy/MM/dd', 'en');
    var productRef = this.productModel.reference;
    if (productRef == null) {
      productRef = " ";
    }
    let docDefinition = {
      header: {
        columns: [
          { text: 'The information provided in this printout is for an item that has not been ordered.  Kawneer accepts no liability for any information in this report.  Items that are ordered will be accompanied by a KawneerDirect order acknowledgement.', style: 'header'}
        ]
      },
      content: [
        {
          image: await this.commonService.getBase64ImageFromURL(
            location.origin.toString() + "/assets/images/kawneer_logo.JPG"
          ),
          alignment: 'center', fit: [150, 150]
        },
        {
          style: 'tableExample', 
          table: {            
            headerRows: 0,
            body: [
              [{ text: 'General', style: 'tableHeader' }],
              
              ["Product Reference " + '\n' + productRef + '\n\n'],
              ["Quantity " + '\n' + this.productModel.quantity + '\n\n'],
              ...this.productModel.productAttributes.map(p =>
              ([
                p.publishedName + '\n' + p.value + '\n\n'
              ])
              ),
            ]
          },
          layout: 'noBorders'
        },
        {
          style: 'tableExample', 
          table: {
            headerRows: 1,
            body: this.buildTableBody().length > 0 ? this.buildTableBody() : [{ text: 'ResourceFrame', style: 'tableHeader' }],
          },
          layout: 'noBorders'
        },
        {
          style: 'tableExample', 
          table: {
            headerRows:1,
            body: [
              [{ text: 'Fills', style: 'tableHeader' }],
                ...this.productModel.fills.map(f =>
                ([
                  'Quantity' + '\n' + f.quantity + '\n\n' + 'Width' + '\n' + f.width + '\n \n' +
                  'Height' + '\n' + f.height + '\n\n' +
                  'Thichness' + '\n' + f.thickness + '\n\n'
                ])
                ),
            ]
          },
          layout: 'noBorders'
        }
      ],
      footer: {
        columns: [
          { text: 'Â©1991-2021 Arconic. All rights reserved.', alignment: 'center' }
        ]
      },
      styles: {
        sectionHeader: {
          bold: true,
          decoration: 'underline',
          fontSize: 12,
          margin: [0, 15, 0, 15]
        },
        tableExample: {
          //bold: true,
          //decoration: 'underline',
          fontSize: 14,
          margin: [0, 15, 0, 15]
        },
        header: {
          fontSize: 10,
          margin: [5, 5, 5, 10]
        },
        tableHeader: {
          bold: true,
          fontSize: 14,
          color: 'black',
          margin: [0, 15, 0, 15]
        },
        subheader: {
          decoration: 'underline',
          fontSize: 12,
          bold: true,
          margin: [0, 10, 0, 5]
        }
      }
    };
    this.buildNestedTableBody();
    for (const loc of this.nestedTable) {
      docDefinition.content.push(loc);
    }
    pdfMake.createPdf(docDefinition).download('ProductSummary.pdf');
  }

}
